<template>
  <li>
    <h2 class="h3">Capabilities Requiring Development</h2>

    <div class="row">
      <div class="col-lg-4">
        <div class="form-group">
          <label class="control-label">Program</label>
          <multiselect
            @input="handleSelectProgramCallback"
            :value="programSelected"
            :options="programs"
            track-by="id"
            label="name"
            v-validate="'required'"
            name="program"
            data-vv-validate-on="input|blur"
            :allow-empty="false"
            :searchable="true"
            :show-labels="false"
            :class="[errorClass('program'), validClass('program')]"
            placeholder/>

            <help-block field="program"/>
        </div><!-- /.form-group -->
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label class="control-label">Placement</label>
          <multiselect
            v-model="params.placements"
            :multiple="true"
            :options="placementOptions"
            track-by="id"
            label="number"
            name="placement"
            :searchable="false"
            :show-labels="false"
            :show-no-results="true"
            placeholder="All Placements"/>

        </div><!-- /.form-group -->
      </div>
      <div class="col-lg-4 text-right">
        <ladda-button :click="handleGenerateReport" :validate="true" class="btn btn-info mt-lg-label">
          <font-awesome :icon="['far', 'file-spreadsheet']"/> Download CSV
        </ladda-button>
      </div>
    </div><!-- /.row -->
  </li>
</template>

<script>
import { programComputed } from 'vx/helpers'
import { http } from 'utils'
import { map } from 'lodash'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },

  data () {
    return {
      params: {
        program_id: null,
        placements: null
      },
      programSelected: null,
      placementSelected: null
    }
  },

  computed: {
    ...programComputed,

    placementOptions () {
      let options = this.programSelected ? this.programSelected.placements : []

      return options
    }
  },

  methods: {
    handleSelectProgramCallback (program) {
      this.programSelected = program

      this.params.program_id = program
        ? program.id
        : null

      this.params.placements = null
    },

    async handleGenerateReport () {
      let params = {
        program_id: this.params.program_id,
        placement_ids: map(this.params.placements, 'id')
      }

      return http.get(`reports/capabilities`, { responseType: 'blob', params }).then(response => {
        let now = moment().format('DD-MM-YYYY-HH-mm')

        let filename = `capabilities-requiring-development-${now}.csv`

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(response.data, filename)
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
    }
  }
}
</script>
